import { NgModule } from '@angular/core';
import { GenLoginFormModule } from './login-form/login-form.module';
import { GenLoginModule } from './login/login.module';

@NgModule({
  imports: [
    GenLoginModule, GenLoginFormModule,
  ]
})
export class GenUserAccountModule {}
